import React from 'react';
import InputList from '@alltrails/shared/components/InputList';
import RadioButton24 from '@alltrails/shared/components/RadioButton24';
import { Variant } from '@alltrails/shared/components/FormSelectorBase';
import { FilterConfigToggle, FilterConfigToggleEntry, FilterConfigToggleKey } from 'types/Search';

export type RadioGroupProps = {
  className?: string;
  config: FilterConfigToggle;
  filterName: string;
  handler: (changes: FilterConfigToggle) => void;
  useColumns?: boolean;
  variant?: Variant;
};

const onChange = (config: FilterConfigToggle, selectedKey: FilterConfigToggleKey): Record<FilterConfigToggleKey, FilterConfigToggleEntry> =>
  Object.keys(config).reduce(
    (memo, nextKey: FilterConfigToggleKey) => ({
      ...memo,
      [nextKey]: {
        ...config[nextKey],
        selected: nextKey === selectedKey
      }
    }),
    {} as FilterConfigToggle
  );

const RadioGroup = ({ className = '', filterName, config, handler, useColumns = false, variant = Variant.DEFAULT }: RadioGroupProps) => (
  <InputList useColumns={useColumns}>
    {Object.keys(config).map((key: FilterConfigToggleKey) => {
      const option = config[key];

      return (
        <RadioButton24
          className={className}
          id={key}
          key={`${filterName}:${key}`}
          name={filterName}
          value={key}
          checked={option.selected}
          onChange={() => handler(onChange(config, key))}
          inputType="radio"
          labelComponent={<>{option.name}</>}
          variant={variant}
        />
      );
    })}
  </InputList>
);

export default RadioGroup;
